'use client';

export { AccessibleIcon } from '@radix-ui/react-accessible-icon';
